import { ChevronDown } from 'lucide-react'
import type { ReactNode } from 'react'
import { cn } from '@/src/utils/styles'

interface CounterBadgeProps {
  count: number | string
  className?: string
  disableHover?: boolean
  hoverIcon?: ReactNode
  ringClassName?: string
  countClassName?: string
  iconClassName?: string
}

export const CounterBadge = ({
  count,
  className,
  disableHover = false,
  hoverIcon = <ChevronDown size={16} className='size-4 text-primary' />,
  ringClassName = 'ring-background',
  countClassName,
  iconClassName,
}: CounterBadgeProps) => {
  return (
    <div
      className={cn(
        'bg-surface3-100 ring-2 rounded-full flex items-center justify-center absolute bottom-0 right-0 transition-all w-fit h-[1.1875rem] min-w-[1.1875rem] pointer-events-none',
        ringClassName,
        className,
      )}
    >
      <div className={cn('relative flex items-center justify-center')}>
        <span
          className={cn(
            'text-xs text-primary transition-opacity',
            countClassName,
          )}
        >
          {count.toString().length > 99 ? '99+' : count}
        </span>
        {!disableHover && (
          <div
            className={cn(
              'absolute transition-opacity opacity-0',
              iconClassName,
            )}
          >
            {hoverIcon}
          </div>
        )}
      </div>
    </div>
  )
}
